import {
  FETCH_COUNTRY_SITES,
  FETCH_COUNTRY_SITES_REQUEST,
  FETCH_COUNTRY_SITES_SUCCESS,
  FETCH_COUNTRY_SITES_FAILURE,
  RESET_COUNTRY_SITE_SEARCH
} from './constants';

export function fetchCountrySites({trial_id,language,country}) {
  return {
    type: FETCH_COUNTRY_SITES,
    trial_id,
    language,
    country
  };
}
export function fetchCountrySitesRequest() {
  return {
    type: FETCH_COUNTRY_SITES_REQUEST
  };
}

export function fetchCountrySitesError(message) {
  return {
    type: FETCH_COUNTRY_SITES_FAILURE,
    message,
  };
}

export function fetchCountrySitesSuccess({data, count, total}) {
  return {
    type: FETCH_COUNTRY_SITES_SUCCESS,
    data,
    state_count: count,
    site_count: total
  };
}

export function resetCountrySiteSearch() {
  return {
    type: RESET_COUNTRY_SITE_SEARCH
  }
}
